module.exports = __webpack_public_path__ + "static/media/puzzle-2-bg.24a34c58.svg";